module.exports = __webpack_public_path__ + "img/logo-zhc.5d5a4edc.png";